/* global swal  angular*/
import './style.less';
import { vendor } from 'postcss';

export default function($log, $state) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;
  vm.activate = activate;

  vm.courseState = $state.current.name === 'app.author.courses.course.edit';

  vm.resetCredit = () => {
    vm.price = 0;
  };

  vm.resetOther = () => {
    vm.priceTerms = '';
    vm.priceText = '';
  };

  function activate() {
    $log.debug('Price Editor Component Activated');
    vm.priceType = vm.priceType || 'credit';
    vm.price = vm.price || 0;
    vm.priceTerms = vm.priceTerms || '';
    vm.priceText = vm.priceText || '';
    vm.loaded = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/priceEditor/controller.js